import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';

@Pipe({
    name: 'shortDate',
    standalone: false
})
export class ShortDatePipe implements PipeTransform {
  transform(value: string | Date | null): string {
    const dateTime = dayjs(value);
    return dateTime.format('MM/DD/YYYY');
  }
}
